import { connect } from 'react-redux';
import ThumbList from './ThumbList';

const mapState = (state, props) => ({
  ...props,
  fenderConnect: state.fenderConnect,
});

const mapDispatch = {};

export default connect(
  mapState,
  mapDispatch,
)(ThumbList);
